module.exports = __webpack_public_path__ + "img/ios5icon4.942189da.png";